import {
  ChildAccountDisplayObject,
  ChildAccountErrorsByName,
} from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';
import { parentLevelErrorsMapping } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/ChildAccountTable/ChildAccountTableErrors/ChildAccountTableErrors';

export const createTableErrorsText = (
  errorsByName: ChildAccountErrorsByName = {},
  childAccounts: Array<Pick<ChildAccountDisplayObject, 'name'>> = []
): string | null => {
  const entries = Object.entries(errorsByName);

  if (entries.length === 0) {
    return null;
  }

  const parentLevelErrors = errorsByName.parent_level_error;

  const numberOfRowErrors = childAccounts.reduce((acc, childAccount) => {
    const childRowHasError = !!errorsByName[childAccount.name];

    return childRowHasError ? acc + 1 : acc;
  }, 0);

  const errors: string[] = [];

  if (parentLevelErrors?.length) {
    parentLevelErrors.forEach((error) => {
      errors.push(parentLevelErrorsMapping[error] || error);
    });
  }

  if (numberOfRowErrors) {
    const errorsString = numberOfRowErrors === 1 ? 'error' : 'errors';
    errors.push(`${numberOfRowErrors} row ${errorsString}`);
  }

  return errors.join(' • ') || null;
};
